import { basicEnum } from "./base";

export const InvoiceStatusEnum = basicEnum([
    {
        label: "Menunggu",
        value: "U",
    },
    {
        label: "Lunas",
        value: "P",
    },
    {
        label: "Dibatalkan",
        value: "C",
    },
    {
        label: "Diabaikan",
        value: "W", // Waive
    },
]);

export namespace InvoiceStatusEnum {
    export type Labels = (typeof InvoiceStatusEnum)["labels"][number];
    export type Values = (typeof InvoiceStatusEnum)["values"][number];
}
